// extracted by mini-css-extract-plugin
module.exports = {"bio":"bio-module--bio--3cpvH","pinned":"bio-module--pinned--2JtwN","large":"bio-module--large--3h1hP","dateWrap":"bio-module--date-wrap--1UkfT","time":"bio-module--time--3bynS"};